import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './Components/login/login.component';
import {HomeComponent} from './Components/home/home.component';
import {RouteGuardService} from './route-guard.service';
import {CustomerRegistryComponent} from './Components/customerRegistry/customerRegistry.component';
import {CustomerUserRegistryComponent} from './Components/customerUserRegistry/customerUserRegistry.component';
import {Paths} from './Utils/paths';
import {CommonModule} from '@angular/common';
import {E015UserRegistryComponent} from './Components/e015UserRegistry/e015UserRegistry.component';
import {PublicMapComponent} from "./Components/publicMap/publicMap.component";
import {
  CustomerProductItemRegistryComponent
} from "./Components/customerProductItemRegistry/customerProductItemRegistry.component";
import {ProductTypeRegistryComponent} from "./Components/productTypeRegistry/productTypeRegistry.component";
import {ChargerRegistryComponent} from "./Components/chargerRegistry/chargerRegistry.component";

const routes: Routes = [
  {
    path: Paths.LOGIN,
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: Paths.PUBLIC_MAP,
    component: PublicMapComponent,
    pathMatch: 'full',
  },
  {
    path: Paths.HOME,
    component: HomeComponent,
    canActivate: [
      RouteGuardService
    ],
    children: [
      {
        path: Paths.CUSTOMER_REGISTRY,
        component: CustomerRegistryComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.CUSTOMER_PRODUCT_ITEM_REGISTRY,
        component: CustomerProductItemRegistryComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.CUSTOMER_USER_REGISTRY,
        component: CustomerUserRegistryComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.E015_USER_REGISTRY,
        component: E015UserRegistryComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.PRODUCT_TYPE_REGISTRY,
        component: ProductTypeRegistryComponent,
        canActivate: [
          RouteGuardService
        ]
      },
      {
        path: Paths.CHARGERS_REGISTRY,
        component: ChargerRegistryComponent,
        canActivate: [
          RouteGuardService
        ]
      }
    ]
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
